export const APP_ROUTE = {
	MAIN_APP_ROUTE_PATH: "/app"
};

const prefix = APP_ROUTE.MAIN_APP_ROUTE_PATH;

export const PAGES_PATH = {
	PAGE_CBS_POST_PATH: `${prefix}/posts`,
	PAGE_CBS_NOTE_PATH: `${prefix}/notes`,
	PAGE_CBS_LOGIN_PATH: `${prefix}/login`,
	PAGE_TUYEN_SINH_PATH: `${prefix}/tuyen-sinh-2025`,
	PAGE_CMD_VIEW_2025_PATH: `${prefix}/xem-tuyen-sinh-2025`,
	PAGE_CBS_CHANGE_ROLE_PATH: `${prefix}/change-role`,
	PAGE_CBS_DEVICE_PATH: `${prefix}/devices`,
	PAGE_CBS_TODO_PATH: `${prefix}/todo-list`,
	PAGE_CBS_REQUEST_PATH: `${prefix}/requests`,
	PAGE_CBS_EMPLOYEE_PATH: `${prefix}/employees`,
	PAGE_NOTIFICATIONS_PATH: `${prefix}/notifications`,
	PAGE_CBS_REPORT_FORM_PATH: `${prefix}/report-form`,
	PAGE_MISSION_OF_DAY_PATH: `${prefix}/mission-of-day`,
	PAGE_CBS_REQUEST_TYPES_PATH: `${prefix}/request-types`,
	PAGE_CBS_DEVICE_REQUEST_PATH: `${prefix}/device-requests`,
	PAGE_CBS_TODO_DEVICES_PATH: `${prefix}/todo-list-devices`,
	PAGE_CBS_MY_TODO_PATH: `${prefix}/todo-list/assigned-to-me`,
	PAGE_CBS_REPORT_FORM_CONFIG_PATH: `${prefix}/report-form/:id`,
	PAGE_CBS_REQUEST_TYPES_CONFIG_PATH: `${prefix}/request-types/:id`,
	PAGE_CBS_DEVICE_BY_CATEGORY_PATH: `${prefix}/devices/:categoryId`,
	PAGE_CBS_MY_CREATED_TODO_PATH: `${prefix}/todo-list/created-by-me`,
	PAGE_CBS_MY_FOLLOWING_TODO_PATH: `${prefix}/todo-list/following-by-me`,
	PAGE_CBS_REQUESTS_CREATED_BY_ME_PATH: `${prefix}/requests/created-by-me`,
	PAGE_CBS_EMPLOYEE_BY_DEPARTMENT_PATH: `${prefix}/employees/:departmentId`,
	PAGE_CBS_REQUESTS_RELATING_TO_ME_PATH: `${prefix}/requests/relating-to-me`,
	PAGE_CBS_REQUESTS_APPROVE_BY_ME_PATH: `${prefix}/requests/approve-by-me`,
	PAGE_CBS_CUSTOMER_PATH: `${prefix}/customer`,
	PAGE_CBS_MY_SCHEDULE_TODO_PATH: `${prefix}/todo-list/schedule-by-me`,
	PAGE_CBS_USER_GUIDE: `${prefix}/todo-list/user-guide`,
	PAGE_CBS_USER_GUIDE_POST_PATH: `${prefix}/todo-list/user-guide-posts`,
	PAGE_CBS_CUSTOMER_DEBPT_REPORTING_PATH: `${prefix}/customer/debt-reporting`,
	PAGE_CBS_TAG_LIST_PATH: `${prefix}/tag-list`,
	PAGE_CBS_CUSTOMER_CLASSIFICATION_PATH: `${prefix}/cbs-customer-classification`,
	PAGE_CBS_CUSTOMER_LIST_PRODUCTS_PATH: `${prefix}/cbs-customer-list-products`,
	PAGE_CBS_CUSTOMER_QUOTE_PATH: `${prefix}/cbs-customer-quote`,
	PAGE_CBS_ALARM_PATH: `${prefix}/cbs-alarms-list`,
	PAGE_CBS_ALARM_SETTING_PATH: `${prefix}/cbs-alarm-setting-list`,
	PAGE_CBS_ECONOMIC_CONTRACT_PATH: `${prefix}/cbs-alarm-economic_contract-list`,
	PAGE_CBS_INVENTORY_PATH: `${prefix}/cbs-inventoires-list`,
	PAGE_CBS_KCS_PATH: `${prefix}/cbs-kcs-list`,
	PAGE_CBS_EVENT_PATH: `${prefix}/events`,
	PAGE_CBS_EVENT_CONFIRMATION_PATH: `${prefix}/events/confirmation/:eventId`,
	PAGE_CMD_2025_PATH: `/cmd-2025`,
	PAGE_CMD_VIE_2025_PATH: `/cmd-view-2025`,
	PAGE_CBS_ACTIVITY_PATH: `${prefix}/activities`,
};

export const PAGES_NAME = {
	PAGE_CBS_POST_NAME: "cbs-posts",
	PAGE_CBS_NOTE_NAME: "cbs-notes",
	PAGE_CBS_LOGIN_NAME: "cbs-login",
	PAGE_CBS_CHANGE_ROLE_NAME: "cbs-change-role",
	PAGE_CBS_DEVICE_NAME: "cbs-devices",
	PAGE_CBS_TODO_NAME: "cbs-todo-list",
	PAGE_CBS_REQUEST_NAME: "cbs-requests",
	PAGE_MISSION_OF_DAY_NAME: "cbs-mission",
	PAGE_CBS_EMPLOYEE_NAME: "cbs-employees",
	PAGE_CBS_REPORT_FORM_NAME: "cbs-report-form",
	PAGE_NOTIFICATIONS_NAME: "cbs-notifications",
	PAGE_CBS_REQUEST_TYPES_NAME: "cbs-request-types",
	PAGE_CBS_DEVICE_TODO_NAME: "cbs-device-todo-list",
	PAGE_CBS_DEVICE_REQUEST_NAME: "cbs-device-requests",
	PAGE_CBS_MY_TODO_NAME: "cbs-todo-list-assigned-to-me",
	PAGE_CBS_REPORT_FORM_CONFIG_NAME: "cbs-report-form-config",
	PAGE_CBS_DEVICE_BY_CATEGORY_NAME: "cbs-devices-by-category",
	PAGE_CBS_MY_CREATED_TODO_NAME: "cbs-todo-list-created-by-me",
	PAGE_CBS_REQUEST_TYPES_CONFIG_NAME: "cbs-request-type-config",
	PAGE_CBS_MY_FOLLOWING_TODO_NAME: "cbs-todo-list-following-by-me",
	PAGE_CBS_REQUESTS_CREATED_BY_ME_NAME: "cbs-requests-created-by-me",
	PAGE_CBS_EMPLOYEE_BY_DEPARTMENT_NAME: "cbs-employees-by-department",
	PAGE_CBS_REQUESTS_RELATING_TO_ME_NAME: "cbs-requests-relating-to-me",
	PAGE_CBS_REQUESTS_APPROVE_BY_ME_NAME: "cbs-requests-approve-by-me",
	PAGE_CBS_CUSTOMER_NAME: "cbs-customer",
	PAGE_CBS_MY_SCHEDULE_TODO_NAME: "cbs-todo-list-schedule",
	PAGE_CBS_USER_GUIDE: "cbs-user-guide",
	PAGE_CBS_USER_GUIDE_POSTS: "cbs-user-guide-posts",
	PAGE_CBS_CUSTOMER_DEBPT_REPORTING: "cbs-customer-debt-reporting",
	PAGE_CBS_TAG_LIST_NAME: "cbs-tag-list",
	PAGE_CBS_CUSTOMER_CLASSIFICATION_NAME: "cbs-customer-classification",
	PAGE_CBS_CUSTOMER_QUOTE_NAME: "cbs-customer-qoute",
	PAGE_CBS_CUSTOMER_LIST_PRODUCTS_NAME: "cbs-customer-list-products",
	PAGE_CBS_ALARM_NAME: "cbs-alarms-list",
	PAGE_CBS_ALARM_SETTING_NAME: "cbs-alarm-setting-list",
	PAGE_CBS_ECONOMIC_CONTRACT_NAME: "cbs-economic-contracts",
	PAGE_CBS_INVENTORY_NAME: "cbs-inventories-list",
	PAGE_CBS_KCS_NAME: "cbs-kcs-list",
	PAGE_CBS_EVENT_NAME: "cbs-events",
	PAGE_CBS_EVENT_CONFIRMATION_NAME: "cbs-event-confirmation",
	PAGE_CMD_2025_NAME: "cmd-2025",
	PAGE_CMD_VIEW_2025_NAME: "cmd-view-2025",
	PAGE_CBS_ACTIVITY_NAME: "cbs-activities",
};
